"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Field_1 = require("../constants/Field");
var ValueConstants_1 = require("../constants/ValueConstants");
var AbilityService_1 = require("../apiServices/auth/AbilityService");
var lodash_1 = require("lodash");
var Helper = /** @class */ (function () {
    function Helper() {
    }
    Helper.updateTenantSpecificTypeId = function (typeId, tags, strictUpdate) {
        if (strictUpdate) {
            return this.updateTypeId(typeId);
        }
        if (this.isTypeGlobal(tags)) {
            return typeId;
        }
        return this.updateTypeId(typeId);
    };
    Helper.updateTenantSpecificTags = function (tags) {
        if (this.isTypeGlobal(tags)) {
            return tags;
        }
        var hasSource = false;
        var hasTenantId = false;
        var updatedTags = lodash_1.map(tags, function (tag) {
            if (tag.includes(Field_1.FIELD.SOURCE + "=") || tag.includes("" + Field_1.FIELD.SOURCE + Field_1.FIELD.ID + "=")) {
                hasSource = true;
            }
            if (tag.includes("" + Field_1.FIELD.TENANT + Field_1.FIELD.ID + "=")) {
                hasTenantId = true;
                var updatedtag = "" + Field_1.FIELD.TENANT + Field_1.FIELD.ID + "=" + AbilityService_1.AbilityService.tenantId;
                return updatedtag;
            }
            return tag;
        });
        if (!hasSource) {
            updatedTags.push(Field_1.FIELD.SOURCE + "=" + AbilityService_1.AbilityService.tenantId);
        }
        if (!hasTenantId) {
            updatedTags.push("" + Field_1.FIELD.TENANT + Field_1.FIELD.ID + "=" + AbilityService_1.AbilityService.tenantId);
        }
        return updatedTags;
    };
    Helper.isTypeGlobal = function (tags) {
        var hasGlobalTenantId = lodash_1.some(tags, function (tag) {
            return tag.includes("" + Field_1.FIELD.TENANT + Field_1.FIELD.ID + "=" + ValueConstants_1.ValueConstants.GlobalTenantId);
        });
        return hasGlobalTenantId;
    };
    Helper.updateTypeId = function (typeId) {
        var splittedTypeId = typeId.split('.');
        var typeIdLength = splittedTypeId.length;
        if (splittedTypeId[typeIdLength - 2] === "" + Field_1.FIELD.TENANT + Field_1.FIELD.ID) {
            splittedTypeId[typeIdLength - 1] = AbilityService_1.AbilityService.tenantId;
        }
        else {
            splittedTypeId.push("" + Field_1.FIELD.TENANT + Field_1.FIELD.ID);
            splittedTypeId.push(AbilityService_1.AbilityService.tenantId);
        }
        var updatedTypeId = splittedTypeId.join('.');
        if (!lodash_1.startsWith(updatedTypeId, ValueConstants_1.ValueConstants.TypeIdPrefix)) {
            updatedTypeId = ValueConstants_1.ValueConstants.TypeIdPrefix + "." + updatedTypeId;
        }
        return updatedTypeId;
    };
    Helper.validateTypeForTenantTags = function (tags) {
        var hasTenantIdTag = lodash_1.some(tags, function (tag) {
            return tag.includes("" + Field_1.FIELD.TENANT + Field_1.FIELD.ID + "=");
        });
        if (!hasTenantIdTag) {
            return false;
        }
        else {
            var hasGlobalTenantId = lodash_1.some(tags, function (tag) {
                return tag.includes("" + Field_1.FIELD.TENANT + Field_1.FIELD.ID + "=" + ValueConstants_1.ValueConstants.GlobalTenantId);
            });
            return !hasGlobalTenantId;
        }
    };
    return Helper;
}());
exports.Helper = Helper;
//# sourceMappingURL=Helper.js.map